<!-- Adapted from Koel ui/ScreenEmptyState.vue, 40183ac (MIT). -->
<template>
  <article class="koel-empty-state" data-upstream-component="Koel/ScreenEmptyState"><div class="empty-copy"><span class="jumbo-icon" aria-hidden="true"><slot name="icon">♫</slot></span><div class="text"><slot /></div></div></article>
</template>
<script>
export default { name: 'KoelEmptyState' };
</script>
<style scoped>
.koel-empty-state { display: flex; justify-content: center; align-items: center; padding: 38px 18px; color: var(--salt-text-secondary, var(--color-text-secondary)); }
.empty-copy { display: flex; flex-direction: column; align-items: center; gap: 14px; max-width: 560px; }
.jumbo-icon { display: block; font-size: 48px; opacity: .55; }
.text { display:flex; flex-direction:column; align-items:center; gap:12px; text-align:center; font-size:14px; line-height:1.5; }
</style>
